export const appSettings: any = window.golite.settings;